var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pg-ocr__wawa"},[_c('div',{staticClass:"pg-ocr__wawa-eye"},[_c('span',{staticClass:"pg-ocr__wawa-eye-l"}),_vm._v(" "),_c('span',{staticClass:"pg-ocr__wawa-eye-r"})])])
}]

export { render, staticRenderFns }